import Typography from "@mui/material/Typography";
import CheckBoxField from "../../../../shared/form/CheckBoxField";
import BoxContent from "../../../../shared/ui/BoxContent";
import {getRomanNumber} from "../../../../utils/functions";
import RadioField from "../../../../shared/form/RadioField";
import TestStartDate from "./TestStartDate";

const StudentsSelectMultipleClassrooms = ({
                                          classroom,
                                          selectedTeacher,
                                          setSelectedStudentsHandler,
                                          setTeacherHandler,
                                          errors,
                                          handleTestStartDate,
                                      }: any) => {

    return (
        <>
            <BoxContent>
                <>
                    <Typography variant="h1" mb={2}>Numele clasei: ({getRomanNumber(classroom.grade)}) {classroom.name}</Typography>
                    <TestStartDate
                        errors={errors}
                        startDate={classroom.start_date}
                        handleTestStartDate={handleTestStartDate}
                        classroomId={classroom.id}
                        classroomName={classroom.name}
                    />
                    <Typography variant="h2" mb={2}>Profesori</Typography>
                    {classroom.teachers.length === 0 ? (
                        <Typography>Nu sunt profesori adăugați</Typography>
                    ) : (
                        <RadioField
                            row={true}
                            name={`teachers_${classroom.id}`}
                            columns={true}
                            defaultValue={selectedTeacher?.value}
                            onChange={setTeacherHandler}
                            options={classroom.teachers}
                            error={errors.teachers?.message}
                        />
                    )}
                    <Typography variant="h2" mb={2} mt={2}>Elevi ({classroom.students.length})</Typography>
                    {classroom.students.length === 0 ? (
                        <Typography>Nu sunt elevi adăugați</Typography>
                    ) : (
                        <CheckBoxField
                            name="users"
                            type="checkbox-group"
                            label="Alege elevii"
                            labelPlacement="end"
                            selectAll={false}
                            options={classroom.students}
                            onChange={setSelectedStudentsHandler}
                            columns={true}
                            error={errors.users?.message}
                        />
                    )}
                </>

            </BoxContent>

        </>
    )
}

export default StudentsSelectMultipleClassrooms;